<template>
  <LayoutsSectionCardTemplate>
    <template #title>
      {{ content.title }}
    </template>
    <template #description>
      {{ content.description }}
    </template>
    <template #action>
      <div class="flex items-center lg:flex-row flex-col gap-4 mt-10">
        <a
          :href="useRuntimeConfig().public.app_user_url"
          target="_blank"
          class="flex items-center gap-2 h-[50px] px-8 rounded-3xl bg-success-strong text-white drop-shadow-md hover:drop-shadow-xl"
        >
          {{ $t("try_free_now") }}</a
        >
        <a
          :href="useRuntimeConfig().public.app_user_url + '/page-builder'"
          target="_blank"
          class="flex items-center gap-2 h-[50px] px-8 rounded-3xl bg-white text-black drop-shadow-md hover:drop-shadow-xl"
        >
          {{ $t("try_page_editor") }}</a
        >
      </div>
    </template>
    <template #image>
      <nuxt-img
        loading="lazy"
        src="/analytics-left.png"
        class="md:block hidden"
        format="webp"
        width="500"
        alt="Create, manage and track all your QR Codes."
      />
    </template>
  </LayoutsSectionCardTemplate>
</template>
<script lang="ts" setup>
interface Content {
  locale: string;
  title: string;
  description: string;
}

const contentLocal: Array<Content> = [
  {
    locale: "en",
    title: "QR Code Generator: Create, Manage, and Track Your Custom QR Codes",
    description:
      "Generate and customize stunning QR codes with ease using our QR Code Generator. Add unique colors, logos, and frames to make your QR codes stand out.",
  },

  {
    locale: "fr",
    title:
      "Générateur de codes QR : créez, gérez et suivez vos codes QR personnalisés",
    description:
      "Générez et personnalisez facilement des codes QR époustouflants grâce à notre générateur de codes QR. Ajoutez des couleurs, des logos et des cadres uniques pour que vos codes QR se démarquent.",
  },
  {
    locale: "it",
    title:
      "Generatore di codici QR: crea, gestisci e traccia i tuoi codici QR personalizzati",
    description:
      "Genera e personalizza facilmente straordinari codici QR con il nostro generatore di codici QR. Aggiungi colori, loghi e cornici unici per far risaltare i tuoi codici QR.",
  },
  {
    locale: "de",
    title:
      "QR-Code-Generator: Erstellen, Verwalten und Nachverfolgen Ihrer benutzerdefinierten QR-Codes",
    description:
      "Generieren und passen Sie mit unserem QR-Code-Generator ganz einfach atemberaubende QR-Codes an. Fügen Sie einzigartige Farben, Logos und Rahmen hinzu, damit Ihre QR-Codes hervorstechen.",
  },
  {
    locale: "es",
    title:
      "Generador de códigos QR: crea, administra y rastrea tus códigos QR personalizados",
    description:
      "Genera y personaliza fácilmente códigos QR impresionantes con nuestro generador de códigos QR. Agrega colores, logotipos y marcos únicos para que tus códigos QR destaquen.",
  },
  {
    locale: "nl",
    title: "QR-codegenerator: maak, beheer en volg je aangepaste QR-codes",
    description:
      "Genereer en pas eenvoudig prachtige QR-codes aan met onze QR-codegenerator. Voeg unieke kleuren, logo's en kaders toe om je QR-codes te laten opvallen.",
  },
  {
    locale: "pt",
    title:
      "Gerador de código QR: crie, gerencie e rastreie seus códigos QR personalizados",
    description:
      "Gere e personalize códigos QR impressionantes com facilidade usando nosso Gerador de código QR. Adicione cores, logotipos e molduras exclusivas para destacar seus códigos QR.",
  },
  {
    locale: "ja",
    title: "QRコードジェネレーター：カスタムQRコードの作成、管理、追跡",
    description:
      "QRコードジェネレーターを使用して、見事なQRコードを簡単に生成およびカスタマイズできます。独自のカラー、ロゴ、フレームを追加して、QRコードを際立たせます。",
  },
  {
    locale: "zh",
    title: "二维码生成器：创建、管理和跟踪您的自定义二维码",
    description:
      "使用我们的二维码生成器轻松生成和自定义精美的二维码。添加独特的颜色、徽标和框架，使您的二维码脱颖而出。",
  },
  {
    locale: "vi",
    title: "Trình tạo mã QR: Tạo, quản lý và theo dõi mã QR tùy chỉnh của bạn",
    description:
      "Tạo và tùy chỉnh mã QR tuyệt đẹp một cách dễ dàng bằng Trình tạo mã QR của chúng tôi. Thêm màu sắc, logo và khung độc đáo để làm cho mã QR của bạn nổi bật.",
  },
  {
    locale: "id",
    title: "Pembuat Kode QR: Buat, Kelola, dan Lacak Kode QR Kustom Anda",
    description:
      "Hasilkan dan sesuaikan kode QR yang menakjubkan dengan mudah menggunakan Pembuat Kode QR kami. Tambahkan warna, logo, dan bingkai unik agar kode QR Anda menonjol.",
  },
  {
    locale: "tr",
    title:
      "QR Kod Oluşturucu: Özel QR Kodlarınızı Oluşturun, Yönetin ve İzleyin",
    description:
      "QR Kod Oluşturucumuzu kullanarak çarpıcı QR kodlarını kolayca oluşturun ve özelleştirin. QR kodlarınızın öne çıkmasını sağlamak için benzersiz renkler, logolar ve çerçeveler ekleyin.",
  },
  {
    locale: "hi",
    title:
      "क्यूआर कोड जेनरेटर: अपने कस्टम क्यूआर कोड बनाएं, प्रबंधित करें और ट्रैक करें",
    description:
      "हमारे क्यूआर कोड जेनरेटर का उपयोग करके आसानी से शानदार क्यूआर कोड जेनरेट और कस्टमाइज़ करें। अपने क्यूआर कोड को अलग दिखाने के लिए अद्वितीय रंग, लोगो और फ्रेम जोड़ें।",
  },
  {
    locale: "th",
    title:
      "เครื่องสร้างรหัส QR: สร้าง จัดการ และติดตามรหัส QR แบบกำหนดเองของคุณ",
    description:
      "สร้างและปรับแต่งรหัส QR ที่น่าทึ่งได้อย่างง่ายดายโดยใช้เครื่องสร้างรหัส QR ของเรา เพิ่มสี โลโก้ และเฟรมที่ไม่ซ้ำใครเพื่อให้รหัส QR ของคุณโดดเด่น",
  },
];

const { locale } = useI18n();
const contentLocale = contentLocal.find((item) => item.locale == locale.value);
const content = contentLocale ?? contentLocal[0];
</script>
